import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { releaseServerSession } from '@/services/sessionSignout';

/**
 * The route every logout lands on.
 *
 * Reached both from AuthContext.logout (which has already told the server) and
 * by direct navigation to /signout from elsewhere in the app — which has not.
 * So the server call is made here too, before the tokens are removed: the
 * endpoint identifies the session from them, and it is idempotent, so the
 * double call on the AuthContext path costs nothing.
 *
 * That call is what releases the account's concurrent-login slot. Clearing
 * local storage alone leaves the slot claimed server-side, which is what made
 * "Already signed in elsewhere" appear on every subsequent sign-in.
 */
const SignOut: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    void releaseServerSession();

    // localStorage.clear();
    // sessionStorage.clear();
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_expiration');
    localStorage.removeItem('sidebar_collapsed');
    localStorage.removeItem('sidebar_open');
    localStorage.removeItem('expanded_menu');
    localStorage.removeItem('active_component');
    // NB: device_uid is deliberately kept. It identifies this browser to the
    // concurrent-login guard, and regenerating it on every logout would make
    // this browser look like a new device on the next sign-in - exactly the
    // prompt it exists to prevent.

    navigate("/");
  }, [navigate]);

  return null;
};

export default SignOut;
